module.exports = __webpack_public_path__ + "static/img/centerBg.0ea6a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/home/centerBg.png
// module id = nzZ4
// module chunks = 2